import { cookieUtils } from "./cookie.utils";
import { jwtUtils } from "./jwt.utils";

class StylesUtils {
    corPrimariaPadrao = "#a82339";
    corSecundariaPadrao = "#FFF";
    corTerceariaPadrao = "#c22743";

    adquirirEstilosCookie() {
        let logourl, corpri, corsec, corter;
        if (cookieUtils.verificarCookie("jwt")) {
            const cookieJwt = cookieUtils.adquirirCookie("jwt");
            const cookieDecodificado = jwtUtils.DecodificarJWT(cookieJwt);
        
            ({ logourl, corpri, corsec, corter } = cookieDecodificado);
        };
        const Estilos = {
            LogoUrl: logourl,
            CorPrimaria: corpri? corpri : this.corPrimariaPadrao,
            CorSecundaria: corsec? corsec : this.corSecundariaPadrao,
            CorTercearia: corter? corter : this.corTerceariaPadrao,
        };
        return Estilos;
    }
}

export const stylesUtils = new StylesUtils()